import axios from 'axios'
import create from 'zustand'
import { persist } from 'zustand/middleware'
import Cookies from 'js-cookie'

//#region guideline store
let store = (set) => ({
  // store guidelines
  guidelines: {},
  // get All guidelines
  getGuidelines: async () => {
    // setting token
    let token = Cookies.get('token')

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      params: {
        sortBy: 'note.id',
        orderBy: 'asc',
      }
    }
    // setting url 
    // main url comes from .env file
    const apiResponse = await axios.get(`${process.env.REACT_APP_API}/note`, config)
    set(async (state) => {
      // initilize guidelines state variable to the responsed guidelines if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.guidelines = apiResponse.data
    })
  },

  editGuideline: async (payload, id) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    // setting url 
    // main url comes from .env file 
    const apiResponse = await axios.patch(`${process.env.REACT_APP_API}/note/${id}`, payload, config)
    // update guidelines state variable if update request was succeed
    if (apiResponse?.status === 200) {
      set(async (state) => {
        const result = state.guidelines?.data?.find((guideline, index) => {

          if (guideline.id === id) {
            state.guidelines.data[index] = apiResponse?.data
          }
        })

        state.guidelines = {
          data: [...state.guidelines.data],
          limit: state.guidelines.limit,
          page: state.guidelines.page,
          totalCount: state.guidelines.totalCount,
        }
      })
    }
    return apiResponse
  },
 
})
//#endregion guideline store

// store the state in the browser local storage
// store = persist(store, { name: 'guideline' })

// getting store data in the browser localstorage
const guideline_Store = create(store)

export default guideline_Store
